import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { UsersService } from './services/users.service';
import { MenusService } from './services/menus.service';


import { AhorrosService } from './services/ahorros.service';
import { BanneresService } from './services/banneres.service';
import { CalendariosService } from './services/calendarios.service';
import { CreditosService } from './services/creditos.service';
import { EmpresasesService } from './services/empresases.service';
import { EventosService } from './services/eventos.service';
import { FotosService } from './services/fotos.service';
import { MedicosService } from './services/medicos.service';
import { NoticiasService } from './services/noticias.service';
import { ParticipantesService } from './services/participantes.service';
import { DocumentosService } from './services/documentos.service';
import { BienestarService } from './services/bienestar.service';
import { DatosService } from './services/datos.service';

import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';


// Import containers
import {
  FullLayoutComponent,
  SimpleLayoutComponent
} from './containers';

const APP_CONTAINERS = [
  FullLayoutComponent,
  SimpleLayoutComponent
]

// Import components
import {
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
} from './components';

const APP_COMPONENTS = [
  AppAsideComponent,
  AppBreadcrumbsComponent,
  AppFooterComponent,
  AppHeaderComponent,
  AppSidebarComponent,
  AppSidebarFooterComponent,
  AppSidebarFormComponent,
  AppSidebarHeaderComponent,
  AppSidebarMinimizerComponent,
  APP_SIDEBAR_NAV
]

// Import directives
import {
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
} from './directives';

const APP_DIRECTIVES = [
  AsideToggleDirective,
  NAV_DROPDOWN_DIRECTIVES,
  ReplaceDirective,
  SIDEBAR_TOGGLE_DIRECTIVES
]

const APP_SERVICES = [
  UsersService,
  MenusService,
  AhorrosService,
  BanneresService,
  CalendariosService,
  CreditosService,
  EmpresasesService,
  EventosService,
  FotosService,
  MedicosService,
  NoticiasService,
  ParticipantesService,
  DocumentosService,
  BienestarService,
  DatosService,
  
]

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { ChartsModule } from 'ng2-charts/ng2-charts';

import { GrowlModule } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmationService } from 'primeng/primeng';
@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    ChartsModule,
    HttpModule,
    GrowlModule
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    ...APP_COMPONENTS,
    ...APP_DIRECTIVES,

  ],
  providers: [{
    provide: LocationStrategy,
    useClass: HashLocationStrategy
  }, ...APP_SERVICES, MessageService, ConfirmationService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts